module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_request_003_sm-abdd01b0.png";